import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 14a5 5 0 0 1-5 5H5.636A4.636 4.636 0 0 1 1 14.364V10a5 5 0 0 1 5-5h12.364A4.636 4.636 0 0 1 23 9.636zm-1.523-3.421a.75.75 0 0 0-.954-1.158l-2.558 2.109a.75.75 0 0 0 .954 1.157zm-18.05 4.905a.75.75 0 0 1 .088-1.057l6.5-5.5a.75.75 0 0 1 .97 1.146l-6.5 5.5a.75.75 0 0 1-1.058-.089m9.085.946a.75.75 0 0 0 .976 1.14l2.644-2.264a.75.75 0 0 0-.975-1.14z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_sun_rooftop_filled-B-zDXOu4.js.map
